import { useState } from "react";
import { navLists } from "../constants";
import { FaGithub, FaLinkedin, FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigation = (item) => {
    setMenuOpen(false); // Close the menu after clicking
    if (item.toLowerCase() === "resume") {
      window.location.href = "/resume";
    } else if (item.toLowerCase() === "reel") {
      window.location.href = "/reel";
    } else if (item.toLowerCase() === "about") {
      const aboutSection = document.getElementById("about");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = "/";
      }
    } else if (item.toLowerCase() === "projects") {
      const projectsSection = document.getElementById("projects");
      if (projectsSection) {
        projectsSection.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = "/";
      }
    } else if (item.toLowerCase() === "experience") {
      const experienceSection = document.getElementById("experience");
      if (experienceSection) {
        experienceSection.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = "/";
      }
    } else if (item.toLowerCase() === "contact") {
      window.location.href =
        "mailto:mohdmafaz200303@gmail.com?subject=Let's Connect&body=Hi Mafaz,%0D%0A%0D%0AI'd love to get in touch with you.";
    }
  };

  return (
    <header className="w-full py-4 sm:py-5 px-4 sm:px-10 flex justify-between items-center bg-black text-white sticky top-0 z-50">
      <nav className="flex w-full max-w-7xl mx-auto items-center relative">
        {/* Logo */}
        <p className="text-lg font-semibold whitespace-nowrap">Mohamed Mafaz</p>

        {/* Desktop Navigation */}
        <div className="hidden sm:flex flex-1 justify-center gap-6">
          {navLists.map((item, i) => (
            <div
              key={i}
              className="text-sm cursor-pointer hover:text-gray-400 transition-all"
              onClick={() => handleNavigation(item)}
            >
              {item}
            </div>
          ))}
        </div>

        {/* Social Icons */}
        <div className="flex items-center gap-5 ml-auto sm:ml-0">
          {/* GitHub */}
          <a
            href="https://github.com/Mafaz03"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-gray-400 transition-all animate-bounce"
          >
            <FaGithub />
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/in/mohdmafaz/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl text-blue-400 hover:text-blue-500 transition-all animate-bounce"
          >
            <FaLinkedin />
          </a>

          {/* Mobile Menu Icon */}
          <div
            className="sm:hidden text-2xl cursor-pointer ml-4"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>

        {/* Mobile Dropdown */}
        {menuOpen && (
  <div className="absolute top-16 right-0 w-full bg-black flex flex-col items-center py-4 gap-4 sm:hidden border-t border-gray-700">
    {navLists.map((item, i) => (
      <div
        key={i}
        className="text-sm cursor-pointer text-white hover:text-gray-400 transition-all"
        onClick={() => handleNavigation(item)}
      >
        {item}
      </div>
    ))}
  </div>
)}
      </nav>
    </header>
  );
};

export default Navbar;